/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

window.addEventListener('load', function () {
    // Function to add a class to an element
    function addClass(element, className) {
        if (!element.classList.contains(className)) {
            element.classList.add(className);
        }
    }
    
    // Function to remove a class from an element
    function removeClass(element, className) {
        if (element.classList.contains(className)) {
            element.classList.remove(className);
        }
    }
    
    // Function to handle tab clicks
    function handleTabClick(event) {
        event.preventDefault();
    
        // Remove 'active' class from all tabs
        var tabs = document.querySelectorAll('.p-tabs__tab');
        tabs.forEach(function (tab) {
            removeClass(tab, 'active');
        });
    
        // Add 'active' class to the clicked tab
        addClass(this, 'active');
    
        // Get the data-tab attribute value
        var id = this.getAttribute('data-tab');
    
        // Remove 'active' class from all content
        var contents = document.querySelectorAll('.p-tabs__content');
        contents.forEach(function (content) {
            removeClass(content, 'active');
        });
    
        // Add 'active' class to the corresponding content
        addClass(document.getElementById(id), 'active');

        var top = document.querySelector('.p-tabs__list').getBoundingClientRect().top + window.pageYOffset - 70;
        window.scrollTo({
            top: top,
            behavior: 'instant'
        });
    }
    
    // Function to handle mobile tab clicks
    function handleMobileTabClick(event) {
        event.preventDefault();
    
        if (this.classList.contains('active')) {
            this.classList.toggle('active');
            this.nextElementSibling.style.display = 'none';
        } else {
            var activeTab = document.querySelector('.p-tabs__mob-tab.active');
            if (activeTab) {
                activeTab.nextElementSibling.style.display = 'none';
                removeClass(activeTab, 'active');
            }
    
            this.classList.toggle('active');
            this.nextElementSibling.style.display = 'block';
        }
    }
    
    // Attach click event to each tab
    var tabs = document.querySelectorAll('.p-tabs__tab');
    tabs.forEach(function (tab) {
        tab.addEventListener('click', handleTabClick);
    });
    
    // Attach click event to each mobile tab
    var mobileTabs = document.querySelectorAll('.p-tabs__mob-tab');
    mobileTabs.forEach(function (mobileTab) {
        mobileTab.addEventListener('click', handleMobileTabClick);
    });
})